// extracted by mini-css-extract-plugin
export var arrows = "_2y-6";
export var decrementer = "_2y-a";
export var disabled = "_2y-4";
export var error = "_2y-1";
export var hiddenText = "_2y-b";
export var incrementer = "_2y-9";
export var input = "_2y-8";
export var inputWrapper = "_2y-0";
export var leadingIcon = "_2y-c";
export var readonly = "_2y-3";
export var regular = "_2y-7";
export var small = "_2y-5";
export var warning = "_2y-2";